import { Amplify } from "aws-amplify";
import { Authenticator, translations } from "@aws-amplify/ui-react";
import { I18n } from "aws-amplify/utils";
import { Root } from "./root";
import { getRuntimeAppConfig } from "../config/runtimeAppConfig";

type RuntimeAuthConfig = {
  userPoolId: string;
  userPoolClientId: string;
};

const getEnvAuthConfig = (): RuntimeAuthConfig | null => {
  const userPoolId = import.meta.env.VITE_USER_POOL_ID;
  const userPoolClientId = import.meta.env.VITE_USER_POOL_CLIENT_ID;

  if (!userPoolId || !userPoolClientId) {
    return null;
  }

  return {
    userPoolId,
    userPoolClientId,
  };
};

const getRuntimeAuthConfig = async (): Promise<RuntimeAuthConfig> => {
  const config = await getRuntimeAppConfig();
  if (config.userPoolId && config.userPoolClientId) {
    return {
      userPoolId: config.userPoolId,
      userPoolClientId: config.userPoolClientId,
    };
  }

  const fallbackConfig = getEnvAuthConfig();
  if (fallbackConfig) {
    return fallbackConfig;
  }

  throw new Error(
    "Amplify config ontbreekt: lever /app-config.json aan of zet VITE_USER_POOL_ID en VITE_USER_POOL_CLIENT_ID voor lokaal draaien.",
  );
};

export const configureAmplifyAuth = async () => {
  const config = await getRuntimeAuthConfig();

  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolId: config.userPoolId,
        userPoolClientId: config.userPoolClientId,
      },
    },
  });
};

export const setUpAmplifyTranslation = () => {
  I18n.putVocabularies(translations);

  I18n.setLanguage("nl");

  I18n.putVocabulariesForLanguage("nl", {
    "Sign In": "Inloggen",
    "Sign in": "Inloggen",
    "Sign Out": "Uitloggen",
    Username: "Gebruikersnaam",
    Password: "Wachtwoord",
    "Enter your Username": "Vul je gebruikersnaam in",
    "Enter your Password": "Vul je wachtwoord in",
    "Forgot your password?": "Wachtwoord vergeten?",
    "Reset Password": "Wachtwoord resetten",
    "Back to Sign In": "Terug naar inloggen",
    "User does not exist.": "Gebruiker bestaat niet.",
    "Incorrect username or password.": "Onjuiste gebruikersnaam of wachtwoord.",
  });
};

export const AmplifyAuth = () => {
  return (
    <Authenticator hideSignUp>
      {({ signOut, user }) => (
        <>
          {user && signOut ? (
            <Root user={user} signOut={() => signOut()} />
          ) : (
            <div>User is not logged in</div>
          )}
        </>
      )}
    </Authenticator>
  );
};
